var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"contents"}},[_c('Navigation',{ref:"navigation"}),_c('div',{staticStyle:{"margin-top":"100px"},style:({'min-height': _vm.$route.meta.docs ? 'calc(100vh - 165px)' : 'calc(100vh - 318px)'})},[_c('router-view',{class:{docs: _vm.$route.meta.docs}})],1),_c('Footer',{ref:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }